import { FacilityCard } from '@gyym/ui'
import React from 'react'

import { BaseFacility, buildFacilityLink } from '@/modules/Facilities'
import { useToggleFavorite } from '@/modules/Favorites'

import { Container, Item, List } from './styles'

export interface FacilityListProps {
  facilities: BaseFacility[]
}

export const FacilityCardList = ({ facilities }: FacilityListProps) => {
  const {
    onToggle: onToggleFavorite,
    favoritedFacilityIds,
    isFavoriteLoading,
  } = useToggleFavorite()

  return (
    <Container>
      <List>
        {facilities.map((facility) => (
          <Item key={facility.id}>
            <FacilityCard
              variant="default"
              id={facility.id}
              name={facility.name}
              images={facility.images}
              isFavorited={favoritedFacilityIds.includes(facility.id)}
              onFavoriteClick={onToggleFavorite}
              isFavoriteLoading={isFavoriteLoading}
              station={facility.station}
              minimumPoint={facility.minimumPoint}
              activities={facility.activities}
              {...buildFacilityLink(facility)}
            />
          </Item>
        ))}
      </List>
    </Container>
  )
}
